/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingIdRemarkRuleFormDataBase
 */
export interface BookingIdRemarkRuleFormDataBase {
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleFormDataBase
     */
    bookingIdRemark?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BookingIdRemarkRuleFormDataBase
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleFormDataBase
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleFormDataBase
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BookingIdRemarkRuleFormDataBase
     */
    disabled?: boolean;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof BookingIdRemarkRuleFormDataBase
     */
    providers?: Array<GuidIdAndLabel> | null;
}

export function BookingIdRemarkRuleFormDataBaseFromJSON(json: any): BookingIdRemarkRuleFormDataBase {
    return BookingIdRemarkRuleFormDataBaseFromJSONTyped(json, false);
}

export function BookingIdRemarkRuleFormDataBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingIdRemarkRuleFormDataBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bookingIdRemark': !exists(json, 'bookingIdRemark') ? undefined : json['bookingIdRemark'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function BookingIdRemarkRuleFormDataBaseToJSON(value?: BookingIdRemarkRuleFormDataBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bookingIdRemark': value.bookingIdRemark,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'comment': value.comment,
        'description': value.description,
        'disabled': value.disabled,
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
    };
}


